import React, { useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  Input,
  FormHelperText
} from "@material-ui/core";
import MaskedInput from '@biproxi/react-text-mask';
function TextMaskIBAN(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[A-Z]/,/[A-Z]/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'_'}
      showMask
    />
  );
}

export default function CreditIBANField(
	{
    fieldConfig,
    currentMetafields,
    hideChannels = false,
    channelDisplayNames,
    setMetafieldsValues
	}) {

  const [value, setValue] = useState(null);

  useEffect(() => {
		const externalValue = 
          currentMetafields[0].meta_value
            ? currentMetafields[0].meta_value
            : ""
        ;
    if (externalValue !== value) {
      setValue(externalValue);
    }
  }, [currentMetafields]);

  useEffect(() => {
    if (value !== null) {
      const externalValue = 
          currentMetafields[0].meta_value
            ? currentMetafields[0].meta_value
            : ""
        ;
      if (externalValue !== value)
        setMetafieldsValues(currentMetafields, value);
    }
  }, [value]);
  
	if (!fieldConfig )
		return null;	
	
  const helperText = hideChannels
			? null
			: ( currentMetafields.map((metafield, i) => channelDisplayNames[metafield.channel] + (i < currentMetafields.length - 1 ? ", " : "")) );
  
  return (
    <FormControl key={currentMetafields[0].id}>
      <InputLabel>{fieldConfig.label}</InputLabel>
      <Input
        value={value ? value : ""}
        onChange={(e) => {
          let newValue = e.target.value.replaceAll('_', '').replaceAll(' ', '');
          if (!newValue)
            newValue = "";
          setValue(newValue);
        }}
        onBlur={() => {
          // force rerender to make sure placeholders using the value of this field are updated
          setMetafieldsValues(currentMetafields, value, true);
        }}
        inputComponent={TextMaskIBAN}
        style={{width:250}}
      />
      <FormHelperText>
        {helperText}
      </FormHelperText>
    </FormControl>
	);
}
